"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Функция округления value до 2 знака(сотых).
 * @param value - входное значение (type number)
 * @returns {number} - возврашет округленное значение (type number)
 */
function round(value) {
    return Math.round(value * 100) / 100;
}
exports.round = round;
//# sourceMappingURL=round.js.map